import { render, staticRenderFns } from "./CompanyAttributes.vue?vue&type=template&id=3eb0e798&scoped=true"
import script from "./CompanyAttributes.vue?vue&type=script&lang=js"
export * from "./CompanyAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0e798",
  null
  
)

export default component.exports